import { render, staticRenderFns } from "./BugReportWidget.vue?vue&type=template&id=29870d24&scoped=true&"
import script from "./BugReportWidget.vue?vue&type=script&lang=ts&"
export * from "./BugReportWidget.vue?vue&type=script&lang=ts&"
import style0 from "./BugReportWidget.vue?vue&type=style&index=0&id=29870d24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29870d24",
  null
  
)

export default component.exports